import { isDev, nanoid } from "./util";
import posthog from "posthog-js";

// unique user id
export const lsKeyULID = "fm-ulid";
// dropbox e-mail address
export const lsKeyDropboxEmail = "fm-dbx-email";
// google account info
export const lsKeyGoogleAccount = "fm-google-account";
// Microsoft One Drive account info
export const lsKeyOneDriveAccount = "fm-onedrive-account";

/**
 * get the best uniquely identifying user id
 */
export function getUserID(): string | null {
  let uid = localStorage.getItem(lsKeyDropboxEmail);
  if (!uid) {
    uid = localStorage.getItem(lsKeyULID);
  }
  if (!uid) {
    let acc = localStorage.getItem(lsKeyGoogleAccount);
    if (acc) {
      let o = JSON.parse(acc);
      if (o && o.email) {
        uid = o.email;
      }
    }
  }
  if (!uid) {
    let acc = localStorage.getItem(lsKeyOneDriveAccount);
    if (acc) {
      let o = JSON.parse(acc);
      if (o && o.mail) {
        uid = o.mail;
      }
    }
  }

  // throwIf(!uid, "should have uid");
  return uid;
}

function setupPostHog(uid: string) {
  if (isDev()) {
    console.log("skipping sentry/posthog for localhost");
    return;
  }

  posthog.init("HpRGzml-8jWFFAklHyN7lDtwyTEZspkKLgBASXAQuVA", {
    api_host: "https://us.i.posthog.com",
    // api_host: "https://ph.arslexis.io",
    // ui_host: "https://us.posthog.com",
    person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
  });

  const originalConsoleError = console.error;
  function myConsoleError(...args: any[]) {
    originalConsoleError.apply(console, args);

    let err;
    if (args.length === 1 && args[0] instanceof Error) {
      err = args[0];
    } else {
      let msg = args.join(" ");
      err = new Error("console.error: " + msg);
    }
    posthog.captureException(err);
  }
  console.error = myConsoleError;
  posthog.identify(uid);
}

// create user id on demand and initialize
// functionality that needs user id
export function createUserIDAndIdentify() {
  let uid = getUserID();
  if (!uid) {
    uid = nanoid();
    localStorage.setItem(lsKeyULID, uid);
    // console.log("generated unique user id:", uid);
  } else {
    // console.log("got user id:", uid);
  }

  setupPostHog(uid);
}
